<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			body: ISbStoryData[];
			dont_fill_height: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class="flex w-full items-center justify-center"
	class:h-full={!content.dont_fill_height}
>
	{#each content.body as block}
		<Blok content={block} />
	{/each}
</div>
